<div class="date-range-picker">
  <!-- Input Field -->
  <div class="input-wrapper" [class.floating]="floating" [class.has-value]="displayValue" (click)="toggleCalendar()">
    <div class="input-field">
      <i class="fa fa-calendar-days input-icon"></i>
      <span class="input-value" [class.placeholder]="!displayValue">
        {{ displayValue || placeholder }}
      </span>
      @if (displayValue) {
        <button type="button" class="clear-btn" (click)="clearSelection(); $event.stopPropagation()">
          <i class="fa fa-times"></i>
        </button>
      }
      <i class="fa fa-chevron-down dropdown-icon" [class.open]="isOpen"></i>
    </div>
    @if (floating) {
      <label class="floating-label" [class.active]="displayValue || isOpen">{{ label }}</label>
    }
  </div>

  <!-- Calendar Dropdown -->
  @if (isOpen) {
    <div class="calendar-dropdown">
      <!-- Calendar Header -->
      <div class="calendar-header">
        <button type="button" class="nav-btn" (click)="prevMonth(); $event.stopPropagation()">
          <i class="fa fa-chevron-left"></i>
        </button>
        <span class="month-year">{{ monthYearDisplay }}</span>
        <button type="button" class="nav-btn" (click)="nextMonth(); $event.stopPropagation()">
          <i class="fa fa-chevron-right"></i>
        </button>
      </div>

      <!-- Weekday Headers -->
      <div class="weekdays">
        @for (day of weekDays; track day) {
          <div class="weekday">{{ day }}</div>
        }
      </div>

      <!-- Calendar Grid -->
      <div class="calendar-grid">
        @for (week of calendarDays; track $index) {
          <div class="week-row">
            @for (day of week; track $index) {
              @if (day) {
                <button
                  type="button"
                  class="day-btn"
                  [class.selected]="isSelected(day)"
                  [class.in-range]="isInRange(day)"
                  [class.range-start]="isRangeStart(day)"
                  [class.range-end]="isRangeEnd(day)"
                  [class.today]="isToday(day)"
                  (click)="onDateClick(day); $event.stopPropagation()"
                  (mouseenter)="onDateHover(day)"
                  (mouseleave)="onDateHover(null)"
                >
                  {{ day.getDate() }}
                </button>
              } @else {
                <div class="day-empty"></div>
              }
            }
          </div>
        }
      </div>

      <!-- Selection Info -->
      <div class="selection-info">
        @if (selectionStart && !selectionEnd) {
          <span class="hint">Select end date</span>
        } @else if (selectionStart && selectionEnd) {
          <span class="selected-range">
            {{ formatDisplayDate(selectionStart) }} - {{ formatDisplayDate(selectionEnd) }}
          </span>
        } @else {
          <span class="hint">Select start date</span>
        }
      </div>

      <!-- Actions -->
      <div class="calendar-actions">
        <button type="button" class="btn-clear" (click)="clearSelection(); $event.stopPropagation()">
          Clear
        </button>
        <button type="button" class="btn-apply" (click)="applyAndClose(); $event.stopPropagation()" [disabled]="!selectionStart">
          Apply
        </button>
      </div>
    </div>
  }
</div>
